@if (!isFetching) {
    <div class="trip-card">
        <div [style.background-image]="'url(' + trip?.image_url + ')'"
             class="trip-card__wrapper">
            <div class="trip-card__image"></div>
            <div class="trip-card__title">{{ trip.name }}</div>
        </div>

        <div class="trip-card__details">
            <div class="trip-card__details__item">
                <img alt="Calendar" class="trip-card__details__icon" src="assets/svg/o-calendar.svg">
                <span class="trip-card__details__text">{{ tripRange }} days</span>
            </div>
        </div>

        <div class="trip-card__locales">
            {{ trip?.startCity }} | {{ trip?.endCity }}
        </div>

        <div class="trip-card__body">
            <div class="trip-card__content">
                <div class="trip-card__description">
                    {{ trip.description }}
                </div>
            </div>
        </div>

        @if (showButtonAction) {
            <div class="trip-card__button-box">
                <button (click)="openTripOverview()">
                    <a class="btn-default btn-primary"
                       [href]="trip.url"
                       (click)="ignoreLink($event)"
                    >
                        {{ buttonText }}
                    </a>
                </button>
            </div>
        }
    </div>
} @else {
    <div class="trip-fetching" #tripCard>
        <ngx-skeleton-loader [theme]="{height: tripCard.clientHeight + 'px', margin: 0}"></ngx-skeleton-loader>
    </div>
}
